const downs = {
    path: 'downs-new',
    component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/downsNew'], resolve),
    meta: {
      requireAuth: true
    }
  }
  
  export default downs